import React from 'react';
import axios from 'axios';
import {config} from './../config.js';


class Print extends React.Component {
	constructor(props) {
		  super(props);  	 
		  this.state = {
			letter: null,
			today: '',
			definitions: []
		  };
		}

	componentDidMount() {
		axios.get(config.wsServer+'/apps/ws/styleguide/list/')
	      .then(res => {
	        const definitions = res.data.results;
	        this.setState({ definitions });
	      })
	      
	    const monthNames = ["January", "February", "March", "April", "May", "June",
		  "July", "August", "September", "October", "November", "December"
		];
		
		const d = new Date();
		const month = monthNames[d.getMonth()];
		const day = d.getDate();
		const year = d.getFullYear();

		this.setState({ today: month + ' ' + day + ', ' + year });
	  }

 	
	render() {
		
        return (
        	<div className="printView container">
        		<p className="printToolbar bg-dark text-white p-3">
        			<a href="/apps/styleguide/home" className="btn btn-sm bg-light text-dark float-right">Return to search</a>
        			Use your web browser to print or save as a PDF.
        		</p>
        		<div className="text-center m-5"><img src="https://www.scu.edu/assets/images/SCU-120x120.png" alt="Santa Clara University" /></div>
        			<h1 className="text-center">University Editorial Style Guidelines</h1>
        		<h2 className="text-center">A guide for effective communication</h2>
        		<h3 className="text-center">{this.state.today}</h3>
        		<div className="printIntro">
	        	<h4>A guide for effective communication</h4>
	        	
	        	<p>Wondering how to abbreviate academic degrees? Whether to use the serial comma? When to capitalize academic titles? Or how to choose between “its” or
	        			“it’s”? The University Editorial Style Guide is a tool for everyone writing for print or
	        			electronic publications for Santa Clara University. This guide provides quick
	        			answers to these and many other commonly recurring questions.</p>
	        	<p>This searchable style guide serves as a dictionary, a spelling reference, and a
	        			guide for basic grammar and punctuation. It provides clarification for some
	        			frequently misspelled, misused, and confused words, and lists the proper forms of
	        			University-specific terms and locations. Finally, this guide gives the preferred
	        			usage for Santa Clara publications and communications, to help the University
	        			develop a consistent, unified voice, tone, and style.</p>
	        	<p>The Associated Press Stylebook, which all newspapers use, is heavily relied upon
	        			for this guide, though this guide supersedes the AP Stylebook in several cases.
	        			This version incorporates comments from previous style guides and reflects
	        			several changes on campus. There is a list of University centers and buildings,
	        			including the full names, locations, and common names.</p>
	        	<p>Use Webster’s Dictionary for definitions and spellings not listed in this guide;
	        			where two spellings are given, use the first. The Chicago Manual of Style is the
	        			recommended guide for publication of books, proceedings, papers and articles for
	        			professional journals. The AP Stylebook is used for University news releases, Santa
	        			Clara Magazine, fyi, school and department newsletters and brochures, as well as
	        			most documents targeting a general audience.</p>
	        	<p>Our guide contains style guidelines specific to SCU, and a few exceptions to both
	        			The Associated Press Stylebook and The Chicago Manual of Style. Where conflicts
	        			exist between this and other guides, the SCU style guide takes precedence. For
	        			punctuation, grammar, and other usage questions (e.g., capitalization) that are
	        			not explained in this guide, refer to the AP Stylebook. For basic guidelines on
	        			magazine and book style, consult the latest edition of The Chicago Manual of
	        			Style.</p>
	        	<p>Refer to the <a href="/apps/styleguide/search/352/">Quick Reference Guide</a> for most commonly asked style questions.
	        			If you would like to download a PDF of this style guide, please click on the Print
	        			PDF link in the alpha-grid navigation in the right hand column.
	        			Please keep in mind that this guide is not comprehensive; old information is
	        			routinely deleted and new information added. If there is an omission or
	        			misinformation that needs to be addressed or if you have questions about writing,
	        			grammar, or style that are not included here, please email University Writer/Editor
	        			Harold Gutmann or call him at 551-3117.</p>
	        	</div>
		      	{ this.state.definitions.map(definition => <dl className="row border-top pt-3" key={definition.style_id}><dt className="col-sm-3 text-sm-right" dangerouslySetInnerHTML={{__html:definition.label}} /><dd className="col-sm-9" dangerouslySetInnerHTML={{__html:definition.descr}} /></dl>)} 
		         </div>
        );
  }
}

export default Print;
